/**
 * useAIEvents — convenience hook for consuming the AIEventsContext.
 *
 * Returns the live SSE event queue, unread badge count, and a function to
 * clear the badge (call it when the user visits the AI Activity page).
 */

import { useAIEventsContext, AIEvent } from '../contexts/AIEventsContext.tsx';

export interface UseAIEventsReturn {
  events: AIEvent[];
  latestEvent: AIEvent | undefined;
  unreadCount: number;
  clearUnread: () => void;
  connected: boolean;
}

export function useAIEvents(): UseAIEventsReturn {
  const { events, unreadCount, clearUnread, connected } = useAIEventsContext();
  return {
    events,
    latestEvent: events[0],
    unreadCount,
    clearUnread,
    connected,
  };
}
